const NAVIGATION_EVENT = 'app:navigate';
const NAVIGATION_PATCH_FLAG = '__ccNavigationPatched__';

function normalizeUrl(url) {
  try {
    const resolved = new URL(url, window.location.origin);
    return resolved.pathname || '/';
  } catch (error) {
    return window.location.pathname || '/';
  }
}

function emitNavigation(url) {
  const pathname = normalizeUrl(url);
  window.dispatchEvent(
    new CustomEvent(NAVIGATION_EVENT, {
      detail: { path: pathname },
    })
  );
}

function patchHistoryMethod(methodName) {
  const original = window.history[methodName];
  window.history[methodName] = function patchedHistory(state, title, url) {
    const result = original.apply(this, arguments);
    if (typeof url !== 'undefined') {
      emitNavigation(url);
    }
    return result;
  };
}

export function ensureNavigationEvents() {
  if (window[NAVIGATION_PATCH_FLAG]) {
    return;
  }

  patchHistoryMethod('pushState');
  patchHistoryMethod('replaceState');
  window.addEventListener('popstate', () => emitNavigation(window.location.pathname));
  emitNavigation(window.location.pathname);

  Object.defineProperty(window, NAVIGATION_PATCH_FLAG, {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false,
  });
}

ensureNavigationEvents();

export { NAVIGATION_EVENT };
